package system

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import component.*
import utils.*

class ParallaxSystem(
    private val layers: ParallaxLayers = inject()
) : IteratingSystem( family{ all(PlayerComponent, PhysicComponent)} ) {

    private val delta1 = calculateParallaxDelta(42)
    private val delta2 = calculateParallaxDelta(20)
    private val delta3 = calculateParallaxDelta(6)

    override fun onTickEntity(entity: Entity) {
        val physicComponent = entity[PhysicComponent]
        val playerComp = entity[PlayerComponent]

//        val playerDeltaX = physicComponent.body.position.x - physicComponent.prevPos.x
        val cameraDeltaX = playerComp.cameraContainer.cameraX - playerComp.prevCameraPos.x
//        val viewDeltaX = playerDeltaX * physicComponent.body.world.customScale

        layers.layer1.move(
            -calculateScaledParallaxDelta(cameraDeltaX, delta1)
        )

        layers.layer2.move(
            -calculateScaledParallaxDelta(cameraDeltaX, delta2)
        )

        layers.layer3.move(
            -calculateScaledParallaxDelta(cameraDeltaX, delta3)
        )
    }

    private fun calculateScaledParallaxDelta(viewDeltaX: Double, parallaxDelta: Double): Double {
        return viewDeltaX / 30 * parallaxDelta
    }

    private fun calculateParallaxDelta(seconds: Int): Double {
        return GameDimensions.V_WIDTH / (60.0 * seconds)
    }
}
